"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const dayjs_1 = __importDefault(require("dayjs"));

const index_1 = require("../../../index");

const AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

const dayjs_2 = require("../../../utils/dayjs");

const references = __importStar(require("../../../common/casualReferences"));

class FRCasualDateParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
  innerPattern(context) {
    return /(maintenant|aujourd'hui|demain|hier|cette\s*nuit|la\s*veille)(?=\W|$)/i;
  }

  innerExtract(context, match) {
    let targetDate = dayjs_1.default(context.refDate);
    const lowerText = match[0].toLowerCase();
    const component = context.createParsingComponents();

    switch (lowerText) {
      case "maintenant":
        return references.now(context.reference);

      case "aujourd'hui":
        return references.today(context.reference);

      case "hier":
        return references.yesterday(context.reference);

      case "demain":
        return references.tomorrow(context.reference);

      default:
        if (lowerText.match(/cette\s*nuit/)) {
          dayjs_2.assignSimilarDate(component, targetDate);
          component.imply("hour", 22);
          component.imply("meridiem", index_1.Meridiem.PM);
        } else if (lowerText.match(/la\s*veille/)) {
          targetDate = targetDate.add(-1, "day");
          dayjs_2.assignSimilarDate(component, targetDate);
          component.imply("hour", 0);
        }

    }

    return component;
  }

}

exports.default = FRCasualDateParser;